/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductParams = {
    calculationTarget: ProductParams.calculationTarget;
    coursePrice: number;
    studentCount?: number | null;
    profitGoal: number;
    projectDuration?: number | null;
    newSubscribers?: number | null;
    firstClients?: number | null;
    avgSubDuration?: number | null;
    serviceType?: ProductParams.serviceType | null;
};
export namespace ProductParams {
    export enum calculationTarget {
        PROFIT = 'profit',
        STUDENTS = 'students',
        SUBSCRIBERS = 'subscribers',
    }
    export enum serviceType {
        ONETIME = 'onetime',
        MONTHLY = 'monthly',
    }
}

